import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFileText = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.6673 1.71444V2.6665C11.6673 4.06663 11.6673 4.7667 11.9398 5.30148C12.1795 5.77188 12.5619 6.15434 13.0323 6.39402C13.5671 6.6665 14.2672 6.6665 15.6673 6.6665L16.6194 6.6665M11.6673 1.71444C11.3394 1.6665 10.9473 1.6665 10.2915 1.6665H8.66732C6.80048 1.6665 5.86705 1.6665 5.15402 2.02982C4.52681 2.34939 4.01687 2.85933 3.6973 3.48654C3.33398 4.19957 3.33398 5.133 3.33398 6.99984V12.9998C3.33398 14.8667 3.33398 15.8001 3.6973 16.5131C4.01687 17.1403 4.52681 17.6503 5.15402 17.9699C5.86705 18.3332 6.80048 18.3332 8.66732 18.3332H11.334C13.2008 18.3332 14.1342 18.3332 14.8473 17.9699C15.4745 17.6503 15.9844 17.1403 16.304 16.5131C16.6673 15.8001 16.6673 14.8667 16.6673 12.9998V8.04231C16.6673 7.3865 16.6673 6.99445 16.6194 6.6665M11.6673 1.71444C11.7471 1.72609 11.823 1.74059 11.8981 1.7586C12.2382 1.84026 12.5634 1.97494 12.8616 2.1577C13.198 2.36384 13.4862 2.6521 14.0627 3.2286L15.1052 4.27107C15.6817 4.84758 15.97 5.13583 16.1761 5.47222C16.3589 5.77046 16.4936 6.09561 16.5752 6.43573C16.5932 6.51078 16.6077 6.58675 16.6194 6.6665M6.66732 10.8332H13.334M6.66732 14.1665H10.834",
		stroke: "#3F3F46",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgFileText);
export default ForwardRef;
